export default "__VITE_ASSET__Dn0Hkp9M__"